import { AGENCIES } from 'src/store/ActionTypes';
import CONSTANTS from 'src/store/constants';

const INITIAL_STATE = {
  agencies: [],
  fetchAgenciesStatus: undefined,
  fetchAgenciesError: undefined,
  addAgencyStatus: undefined,
  addAgencyError: undefined,
  deleteAgencyStatus: undefined,
  deleteAgencyError: undefined,
};

// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case AGENCIES.UNSET:
      return {
        ...state,
        [action.payload]: undefined,
      };
    case AGENCIES.FETCH_AGENCIES:
      return {
        ...state,
        fetchAgenciesStatus: CONSTANTS.API.STARTED,
      };
    case AGENCIES.FETCH_AGENCIES_SUCCEEDED:
      return {
        ...state,
        agencies: action.payload,
        fetchAgenciesStatus: CONSTANTS.API.SUCCEEDED,
      };
    case AGENCIES.FETCH_AGENCIES_FAILED:
      return {
        ...state,
        fetchAgenciesError: action.payload,
        fetchAgenciesStatus: CONSTANTS.API.FAILED,
      };
    case AGENCIES.ADD_AGENCY:
      return {
        ...state,
        addAgencyStatus: CONSTANTS.API.STARTED,
      };
    case AGENCIES.ADD_AGENCY_SUCCEEDED:
      return {
        ...state,
        addAgencyStatus: CONSTANTS.API.SUCCEEDED,
      };
    case AGENCIES.ADD_AGENCY_FAILED:
      return {
        ...state,
        addAgencyError: action.payload,
        addAgencyStatus: CONSTANTS.API.FAILED,
      };
    case AGENCIES.DELETE_AGENCY:
      return {
        ...state,
        deleteAgencyStatus: CONSTANTS.API.STARTED,
      };
    case AGENCIES.DELETE_AGENCY_SUCCEEDED:
      return {
        ...state,
        deleteAgencyStatus: CONSTANTS.API.SUCCEEDED,
      };
    case AGENCIES.DELETE_AGENCY_FAILED:
      return {
        ...state,
        deleteAgencyError: action.payload,
        deleteAgencyStatus: CONSTANTS.API.FAILED,
      };
    default:
      return state;
  }
};
